import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const vimeoApi = createApi({
  reducerPath: "vimeoApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}/api`,
  }),

  endpoints: (builder) => ({
    getSubtitlesHistory: builder.query<any, any>({
      query: () => {
        // const store = JSON.parse(localStorage.getItem("persist:root") || "{}");
        // console.log("store", store);
        return {
          url: `genrate-subtitles`,
          //   headers: {
          //     Authorization: store.auth.token,
          //   },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSubtitlesHistoryQuery } = vimeoApi;
